import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Badge, Spinner } from "reactstrap";
import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";
import {
  Block,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  BlockDes,
  DataTableBody,
  DataTableHead,
  DataTableRow,
  DataTableItem,
  Icon,
} from "../../components/Component";
import { handleGetApis } from "../../service/Api";

const formatDate = (d) =>
  d ? new Date(d).toLocaleString("en-IN", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "—";

// Every editable storefront page. A page nobody has saved yet shows the
// built-in copy ("Default"); saving it makes it "Edited".
const PageList = () => {
  const [state, setState] = useState({ loading: true, pages: [], error: "" });

  useEffect(() => {
    let cancelled = false;
    handleGetApis("admin/pages").then((res) => {
      if (cancelled) return;
      setState({
        loading: false,
        pages: res?.data?.success ? res.data.data : [],
        error: res?.data?.success ? "" : "Couldn't load pages.",
      });
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <React.Fragment>
      <Head title="Pages" />
      <Content>
        <BlockHead size="sm">
          <BlockHeadContent>
            <BlockTitle page>Pages</BlockTitle>
            <BlockDes className="text-soft">Text, headings and Google (SEO) details of the storefront pages.</BlockDes>
          </BlockHeadContent>
        </BlockHead>

        <Block>
          <div className="card card-bordered">
            <div className="card-inner p-0">
              {state.loading ? (
                <div className="text-center py-5">
                  <Spinner color="primary" />
                </div>
              ) : state.error ? (
                <div className="text-center py-5 text-danger">{state.error}</div>
              ) : (
                <DataTableBody>
                  <DataTableHead>
                    <DataTableRow>
                      <span>Page</span>
                    </DataTableRow>
                    <DataTableRow size="md">
                      <span>Google title</span>
                    </DataTableRow>
                    <DataTableRow>
                      <span>Status</span>
                    </DataTableRow>
                    <DataTableRow size="md">
                      <span>Last saved</span>
                    </DataTableRow>
                    <DataTableRow className="nk-tb-col-tools text-end">
                      <span>Edit</span>
                    </DataTableRow>
                  </DataTableHead>
                  {state.pages.map((p) => (
                    <DataTableItem key={p.page_key}>
                      <DataTableRow>
                        <span className="tb-lead">{p.label}</span>
                        <span className="sub-text">{p.path}</span>
                      </DataTableRow>
                      <DataTableRow size="md">
                        <span className="tb-sub">{p.meta_title}</span>
                      </DataTableRow>
                      <DataTableRow>
                        <Badge color={p.is_default ? "light" : "success"} className="badge-dim">
                          {p.is_default ? "Default" : "Edited"}
                        </Badge>
                      </DataTableRow>
                      <DataTableRow size="md">
                        <span className="tb-sub">{formatDate(p.updated_at)}</span>
                      </DataTableRow>
                      <DataTableRow className="nk-tb-col-tools text-end">
                        <Link to={`/pages/${p.page_key}`} className="btn btn-sm btn-light btn-icon" aria-label={`Edit ${p.label}`}>
                          <Icon name="edit" />
                        </Link>
                      </DataTableRow>
                    </DataTableItem>
                  ))}
                </DataTableBody>
              )}
            </div>
          </div>
        </Block>
      </Content>
    </React.Fragment>
  );
};

export default PageList;
